/**
 * 会员请求接口
 * @author 王振宇
 * @since 2022-04-17
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    getHandMemberPageList: function getHandMemberPageList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getHandMemberPageList',
        method: 'get',
        params: data
      });
    },
    GET_AGENCY_MEMBER_TOURISTS_PAGE_LIST: function GET_AGENCY_MEMBER_TOURISTS_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getAgencyMemberTouristsPageList',
        method: 'get',
        params: data
      });
    },
    getMatchmakerAuditPageList: function getMatchmakerAuditPageList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getMatchmakerAuditPageList',
        method: 'get',
        params: data
      });
    },
    getMatchmakerMemberPageList: function getMatchmakerMemberPageList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getMatchmakerMemberPageList',
        method: 'get',
        params: data
      });
    },
    GET_MATCHMAKER_MEMBER_STS_PAGE_LIST: function GET_MATCHMAKER_MEMBER_STS_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getMatchmakerMemberStsPageList',
        method: 'post',
        data: data
      });
    },
    GET_MATCHMAKER_TOUR_MEMBER_STS_PAGE_LIST: function GET_MATCHMAKER_TOUR_MEMBER_STS_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getMatchmakerTouristsMemberStsPageList',
        method: 'post',
        data: data
      });
    },
    GET_AGENCY_MEMBER_STS_PAGE_LIST: function GET_AGENCY_MEMBER_STS_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getAgencyMemberStsPageList',
        method: 'post',
        data: data
      });
    },
    GET_MEMBER_PAGE_LIST: function GET_MEMBER_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBER_Tourists_PAGE_LIST: function GET_MEMBER_Tourists_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getTouristsPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBER_LOG_OUT_PAGE_LIST: function GET_MEMBER_LOG_OUT_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getLogOutPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBER_SUM_COUNT: function GET_MEMBER_SUM_COUNT() {
      return request({
        url: '/admin/v1/member/getSumDataCounts',
        method: 'get'
      });
    },
    GET_MEMBER_LIST: function GET_MEMBER_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/getList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBER_INFO: function GET_MEMBER_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MEMBER: function SAVE_MEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBER: function UPDATE_MEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MEMBER: function DELETE_MEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MEMBER: function DELETE_BATCH_MEMBER() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/deleteBatch',
        method: 'delete',
        data: data
      });
    },
    GIVE_MEMBER_TIME: function GIVE_MEMBER_TIME() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/giveMemberTime',
        method: 'post',
        data: data
      });
    },
    GIVE_HAND_MEMBER_TIME: function GIVE_HAND_MEMBER_TIME() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/giveHandMemberTime',
        method: 'post',
        data: data
      });
    },
    ADD_MEMBER_CURRENCY: function ADD_MEMBER_CURRENCY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/addMemberCurrency',
        method: 'post',
        data: data
      });
    },
    ADD_ANGLE_OF_AFFINITY_NUM: function ADD_ANGLE_OF_AFFINITY_NUM() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/addAngleOfAffinityNum',
        method: 'post',
        data: data
      });
    },
    ADD_MEMBER_WARNING: function ADD_MEMBER_WARNING() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/addWarning',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBER_DISPLAY: function UPDATE_MEMBER_DISPLAY() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/updateMemberDisplaySts',
        method: 'post',
        data: data
      });
    },
    updateMatchmakerReview: function updateMatchmakerReview() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/updateMatchmakerReview',
        method: 'post',
        data: data
      });
    },
    /**
     * 批量删除会员信息。
     * @param data
     * @returns {*}
     */
    batchRemoveMember: function batchRemoveMember() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/batchRemoveMember',
        method: 'post',
        data: data
      });
    },
    /**
     * 回显登录账号。
     * @param data
     * @returns {*}
     */
    resultMemberInfo: function resultMemberInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/resultMemberInfo',
        method: 'get',
        params: data
      });
    },
    /**
     * 重置会员 红娘 代理之间的关系。
     * @param data
     * @returns {*}
     */
    resetMemberLinkAgencyAndMatcher: function resetMemberLinkAgencyAndMatcher() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/resetMemberLinkAgencyAndMatcher',
        method: 'post',
        data: data
      });
    },
    /**
     * 取消会员与红娘/代理的关联（物理删除红娘绑定表、代理绑定表记录）。
     * @param data
     * @returns {*}
     */
    cancelMemberMatchmakerRelation: function cancelMemberMatchmakerRelation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/cancelMemberMatchmakerRelation',
        method: 'post',
        data: data
      });
    },
    SAVE_MEMBER_CENTRE_BACKGROUND: function SAVE_MEMBER_CENTRE_BACKGROUND() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/saveMemberCentreBackground',
        method: 'post',
        data: data
      });
    },
    ADD_MEMBER_PIC: function ADD_MEMBER_PIC() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/addMemberPic',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBER_BASIC_INFO: function UPDATE_MEMBER_BASIC_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/updateMemberBasicInfo',
        method: 'post',
        data: data
      });
    },
    MARK_MEMBER_INFORMATION_COMPLETE: function MARK_MEMBER_INFORMATION_COMPLETE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/member/markInformationComplete',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBER_DETAIL_INFO: function UPDATE_MEMBER_DETAIL_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/updateMemberDetailInfo',
        method: 'post',
        data: data
      });
    }
  };
});